import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const apiUrl = process.env.REACT_APP_API_URL;

export async function get(url, callback = null, data = [])
{
    return await apiRequest(url, 'GET', data, callback)
}

export async function post(url, data = null, callback = null)
{
    return await apiRequest(url, 'POST', data, callback)
}

export async function patch(url, data, callback = null)
{
    return await apiRequest(url, 'PATCH', data, callback)
}

export async function put(url, data, callback = null)
{
    return await apiRequest(url, 'PUT', data, callback)
}

export async function doDelete(url, data)
{
    return await apiRequest(url, 'DELETE', data)
}

async function apiRequest(url, method = 'GET', data = null, callback = null, checkAuth = false) {
    const token = localStorage.getItem('token');
    if (!token && url !== '/login' && checkAuth) {
        window.location.href = '/login';
        return;
    }

    const headers = {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };

    const requestOptions = {
        method,
        headers,
        body: method !== 'GET' && data ? JSON.stringify(data) : undefined
    };

    const response = await fetch(apiUrl + url, requestOptions);
    
    if (!response.ok) {
        await handleErrorResponse(response);
        throw new Error()
    }

    const result = await parseResponse(response);
    
    if (result?.message) {
        showSuccessMessage(result.message);
    }
    
    callback?.(result);
    return result;
}

async function parseResponse(response) {
    const contentType = response.headers.get('content-type');
    if (contentType?.includes('application/json')) {
        return response.json();
    }
    return null;
}

async function handleErrorResponse(response) {
    if (response.status === 401) {
        localStorage.removeItem('token');
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return;
    }

    const errorData = await parseErrorResponse(response);
    showErrorMessage(errorData.message || `HTTP Error ${response.status}`);
    logError(errorData);
}

async function parseErrorResponse(response) {
    try {
        const contentType = response.headers.get('content-type');
        if (contentType?.includes('application/json')) {
            const errorData = await response.json();
            return {
                status: response.status,
                message: errorData.message || errorData.error || `HTTP Error ${response.status}`,
                details: errorData.details,
                code: errorData.code
            };
        }
        return {
            status: response.status,
            message: response.statusText || `HTTP Error ${response.status}`
        };
    } catch (e) {
        return {
            status: response.status,
            message: `Request failed with status ${response.status}`
        };
    }
}

function showSuccessMessage(message) {
    toast.success(message);
}

function showErrorMessage(message) {
    toast.error(message);
}

function logError(error) {
    console.error('API Error:', error);
}

export default apiRequest;